import React from 'react';
import Skeleton from 'react-loading-skeleton';
import styled from 'styled-components';

function IndexSkeleton() {
	return (
		<StyledIndexSkeleton>
			<section className="mainResponsiveWrapper">
				<section className="main-wrapper">
					<section className="right-wrapper-loader">
						<section className="detail-loader">
							<Skeleton wrapper={Box} width={'99.8%'} count={1} height={35} />
							<section>
								<Skeleton wrapper={Box} width={'23%'} count={1} height={35} />
								<Skeleton wrapper={Box} width={'74.3%'} count={1} height={35} />
							</section>
							<section>
								<Skeleton wrapper={Box} width={'23%'} count={4} height={275} />
							</section>
							<section>
								<Skeleton wrapper={Box} width={'23%'} count={4} height={275} />
							</section>
						</section>
					</section>
				</section>
			</section>
		</StyledIndexSkeleton>
	);
}
export default IndexSkeleton;

const Box = styled.span`
	margin-right: var(--px-40);
`;
const StyledIndexSkeleton = styled.div`
	background: var(--neutrals-00white);
	display: flex;
	flex-direction: column;
	height: 100%;

	.main-wrapper {
		display: flex;
		position: relative;
		max-width: 2048px;
		overflow: hidden;
		height: 100%;
	}
	.right-wrapper-loader {
		display: flex;
		width: 100%;
		flex: 1 1 0%;
		height: 100%;
	}
	.detail-loader {
		width: 100%;
		vertical-align: top;
		position: relative;
		align-self: Auto;
		display: flex;
		flex-direction: column;
		padding: 10px;
		height: 100%;
	}
`;
